import { SupportedCardGalleryItemProps } from './SupportedCardGalleryItemProps';
import { FiltersMap } from '@wix/bex-core';
import { ActionsCell } from '../ActionsCell';
import { ReactElement } from 'react';
import { AddItemProps, CardGalleryItemProps } from '@wix/design-system';

export interface CardGridItemBaseProps<T, F extends FiltersMap> {
  /**
   * A CardGalleryItem preset to preserve the same card size regardless of the provided data.
   *
   * @example
   * full — renders title + subtitle
   * title — renders only title
   * empty — renders a card without a footer
   *
   * @default title
   * @external
   */
  preset?: 'full' | 'title' | 'empty';
  /**
   * A function that renders a custom item of the grid.
   * Returns a WSR [`CardGalleryItemProps`](https://www.docs.wixdesignsystem.com/?path=/story/components-lists--cardgalleryitem) object
   * @external
   */
  renderItem?: (
    item: T,
    index: number,
  ) => Partial<SupportedCardGalleryItemProps>;
  /**
   * Adds a [`<TableActionCell />`](https://www.docs.wixdesignsystem.com/?path=/story/components-lists-table--tableactioncell) as last column.<br>
   * Must be a [ActionsCellProps](/pages/cairo/?path=/story/components-collection-features--actionscellprops) object, or a function that returns a [ActionsCellProps](/pages/cairo/?path=/story/components-collection-features--actionscellprops) object.<br>
   * @external
   */
  actionsCell?: ActionsCell<T, F>;

  /**
   * A function that renders an [`<AddItem />`](https://www.docs.wixdesignsystem.com/?path=/story/components-lists--cardgalleryitem#Product_list) after all cards in gallery.<br>
   * Note: the `<AddItem />` card will not show when filters are applied, unless the filter is defined with the persistent option.
   * @external
   */
  renderAddItem?: () => ReactElement<AddItemProps>;

  /**
   * Sets placement of background image.
   * @external
   */
  imagePlacement?: CardGalleryItemProps['imagePlacement'];
}
